/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { connect } from "react-redux";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import { Container, Box, Grid } from "@material-ui/core";
import { LabelWithBackLine } from "../../../../../../components/LabelWithBackLine";
import AutomaticResponseForm from "./AutomaticResponseForm";
import { AutomaticResponseListing } from "./AutomaticResponseListing";

const AutomaticResponseView = (props) => {
  const [editingRecord, setEditingRecord] = useState(null);

  const handleSetEditingRecord = (record) => {
    setEditingRecord(record);
  };

  return (
    <Container
      style={{
        boxShadow: "none",
        padding: 0,
        minHeight: "70vh",
      }}
      maxWidth="xl"
    >
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{
            boxShadow: "none",
            width: "100%",
          }}
        >
          <LabelWithBackLine>Respostas</LabelWithBackLine>
          <Box
            display="flex"
            alignItems="center"
            style={{
              padding: 0,
              marginTop: "35px",
              width: "100%",
              marginBottom: "35px",
            }}
            boxShadow="none"
          >
            <AutomaticResponseForm
              editingRecord={editingRecord}
              handleSetEditingRecord={setEditingRecord}
            />
          </Box>
          <LabelWithBackLine>Respostas Cadastradas</LabelWithBackLine>
          <Container
            maxWidth="xl"
            style={{
              boxShadow: "none",
              padding: 0,
              marginTop: "20px",
            }}
          >
            <AutomaticResponseListing
              setEditingRecord={handleSetEditingRecord}
            />
          </Container>
        </Grid>
      </Grid>
    </Container>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(AutomaticResponseView);
